export default "__VITE_ASSET__BN1BlVCk__"